import React, {useEffect, useState} from "react";
import styled from "styled-components";
import IcOrderList from "@assets/icons/ic-order-list.svg";
import IcOrderBox from "@assets/icons/ic-order-box.svg";
import IcFolder from "@assets/icons/ic-folder.svg";
import IcFile from "@assets/icons/ic-file.svg";
import CheckBox from "../common/Checkbox";
import useSWR from "swr";
import moment from "moment";
import {useStore} from "../../app/store";
import {ModalBody} from "./Modal";
import {observer} from "mobx-react";
import {toast} from "react-toastify";

const MainFolderTrashModal = ({entryType, modalMutate, modalDepth}) => {
    const {folderStore, pageStore, confirmStore} = useStore();
    const trashTypeString = `TRASHCAN_${entryType}`;

    useEffect(() => {
        return () => {
            folderStore.clearSaveItems();
            folderStore.clearInModal(modalDepth, trashTypeString);
        }
    }, []);

    // 휴지통 리스트
    const {data: trashList, isLoading, mutate} = useSWR(`/explorer?type=${entryType}&isTrash=true&sort=-expiresAt`);

    useEffect(() => {
        if (!isLoading && trashList !== undefined) {
            // 배열로 데이터 들어왔을때만 실행
            if (!isLoading && trashList.status === "success") {
                folderStore.setFolderList(trashTypeString, trashList.data.folders);
                folderStore.sortTree(folderStore.folders[trashTypeString], '-expiresAt');
                folderStore.setCurrentAfterActionInModal(trashTypeString, modalDepth);
            }
        }
    }, [trashList])


    // 더블클릭시 내용 저장
    let [clickInfo, setClickInfo] = useState(undefined);
    let [clickOpen, setClickOpen] = useState(false);
    let [viewType, setViewType] = useState("gallery");
    let [overFolderName, setOverFolderName] = useState("");
    const [fullNameLocX, setFullNameLocX] = useState(0);
    const [fullNameLocY, setFullNameLocY] = useState(0);
    const [fullNameMargin, setFullNameMargin] = useState(0);

    // 체크박스 개별, 전체선택

    const singleChk = (checked, item) => {
        if (checked) {
            folderStore.pushSaveItems(item)
        } else {
            folderStore.removeSaveItems(item);
        }
    }


    return (
        <ModalBody id="FolderModalTrash">
            <MainFolderTrashModalWrap>
                <div className={"scroll-wrap"}>
                    <div className="scroll-area">
                        <div className="list-box-wrap">
                            <div className="list-box-header">
                                <div className="action-btn-wrap">
                                    <button>
                                    <span className={"active"} onClick={async () => {
                                        if (folderStore.getSaveItems().length === 0) {
                                            return toast("하나 이상의 폴더 혹은 파일을 선택해 주세요.");
                                        }
                                        confirmStore.openConfirm({
                                            confirmText: "확인",
                                            text: "완전 삭제하시겠습니까?",
                                            confirmFunc: async () => {
                                                try {
                                                    await folderStore.completeDeleteList();
                                                    folderStore.clearSaveItems(); // 체크박스 해제
                                                    await mutate();
                                                    await modalMutate();
                                                    if (folderStore.editorBoardList === 'PAGE') {
                                                        await pageStore.fetchNotificationPageListOnly(folderStore.getCurrent(folderStore.editorBoardList))
                                                    }
                                                    toast("완전 삭제 되었습니다.");
                                                } catch (e) {
                                                    folderStore.clearSaveItems();
                                                    console.log("err===>", e);
                                                } finally {
                                                    confirmStore.clear();
                                                }
                                            },
                                        });
                                    }}>
                                        완전삭제
                                    </span>
                                    </button>
                                    <button>
                                        <span className={"active"} onClick={async () => {
                                            try {
                                                if (folderStore.getSaveItems().length === 0) {
                                                    return toast("하나 이상의 폴더 혹은 파일을 선택해 주세요.");
                                                }
                                                await folderStore.restoreList();
                                                folderStore.clearSaveItems(); // 체크박스 해제
                                                await mutate();
                                                await modalMutate();
                                                if (folderStore.editorBoardList === 'PAGE') {
                                                    await pageStore.fetchNotificationPageListOnly(folderStore.getCurrent(folderStore.editorBoardList))
                                                }
                                                toast("복원이 완료되었습니다.");
                                            } catch (e) {
                                                folderStore.clearSaveItems(); // 체크박스 해제
                                                console.log("err===>", e.message);
                                            }
                                        }}>복원</span>
                                    </button>
                                </div>
                                <div className="ordering-btn-wrap">
                                    <button className={"gallery"} onClick={() => setViewType("gallery")}>
                                        <img src={IcOrderBox} alt="box icon"/>
                                    </button>
                                    <button className={"list"} onClick={() => setViewType("list")}>
                                        <img src={IcOrderList} alt="list icon"/>
                                    </button>
                                </div>
                            </div>

                            <div className={`list-box-container ${viewType}`}>
                                {
                                    folderStore.folders[trashTypeString].children.concat(folderStore.folders[trashTypeString].files).map((el, idx) => (
                                        <div className="box-wrap" key={idx}>
                                            <div className="list-thumbnail-wrap"
                                                 onDoubleClick={() => {
                                                     setClickOpen(true)
                                                     setClickInfo(el)
                                                 }}
                                            >
                                                <CheckBox
                                                    id={"tList_" + idx}
                                                    onChange={(e) => {
                                                        singleChk(e.target.checked, el)
                                                    }}
                                                    children={""}
                                                    className={"checkbox"}
                                                    checked={folderStore.checkSaveItems(el)}
                                                />
                                                <div className="thumbnail-wrap">
                                                    <img src={el.path ? IcFolder : IcFile}
                                                         alt="folder icon"/>
                                                </div>
                                                <div className={"restDate"}>
                                                    {moment(el.expiresAt).diff(moment(), 'days')} 일
                                                </div>
                                                <div className="list-name-wrap">
                                                    <span
                                                        onMouseOver={(event) => {
                                                            setFullNameLocX(event.target.getBoundingClientRect().x)
                                                            setFullNameLocY(event.target.getBoundingClientRect().y)
                                                            setFullNameMargin((event.target.offsetWidth - event.target.parentElement.offsetWidth) / 2);
                                                            if (viewType === 'gallery') {
                                                                if (event.currentTarget.offsetWidth > 109) {
                                                                    setOverFolderName(el.name);
                                                                }
                                                            } else if (viewType === 'list') {
                                                                if (event.currentTarget.offsetWidth > 369) {
                                                                    setOverFolderName(el.name);
                                                                }
                                                            }
                                                        }}
                                                        onMouseLeave={(event) => {
                                                            setOverFolderName("");
                                                            setFullNameLocX(0);
                                                            setFullNameLocY(0);
                                                            setFullNameMargin(0);
                                                        }}
                                                    >{el.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                    <LeftNavigation>
                        <div className="header">
                            <h1>정보</h1>
                        </div>
                        {
                            clickOpen ?
                                <div>
                                    <div className={"folder-name"}>
                                        <img src={clickInfo.path ? IcFolder : IcFile} alt="folder icon"/>
                                        <span className={"name"}>{clickInfo.name}</span>
                                    </div>
                                    <div className={"folder-info"}>
                                        <ul>
                                            <li>
                                                <div className={"title"}>종류 :</div>
                                                <div
                                                    className={"desc"}>{!!clickInfo.depth ? "폴더" : "보드"}</div>
                                            </li>
                                            <li>
                                                <div className={"title"}>이전 경로 :</div>
                                                <div
                                                    className={"desc"}>{clickInfo.prevPath?.split(`${entryType},`)[1].slice(0, -1).replaceAll(",", " > ")}</div>
                                            </li>
                                            <li>
                                                <div className={"title"}>삭제 일시 :</div>
                                                <div
                                                    className={"desc"}>{moment(clickInfo.expiresAt).format("YYYY-MM-DD HH:mm:ss")}</div>
                                            </li>
                                            <li>
                                                <div className={"title"}>생성 일시 :</div>
                                                <div
                                                    className={"desc"}>{moment(clickInfo.createdAt).format("YYYY-MM-DD HH:mm:ss")}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                : <div className={"folder-info"}>
                                    <div className="noData">
                                        폴더 또는 파일을 더블 클릭하면<br/>
                                        정보를 확인하실 수 있습니다.
                                    </div>
                                </div>
                        }
                    </LeftNavigation>
                </div>
            </MainFolderTrashModalWrap>


            {
                overFolderName !== '' &&
                <div className={"full-name"} style={{
                    top: `${fullNameLocY + 20}px`,
                    left: `${fullNameLocX}px`,
                    marginLeft: `-${fullNameMargin}px`
                }}>{overFolderName}</div>
            }
        </ModalBody>
    );
};
const MainFolderTrashModalWrap = styled.div`
    width: 100%;
    height: 100%;

    .scroll-wrap {
        display: flex;
        justify-content: center;
        height: 100%;
    }

    div.scroll-area {
        position: relative;
        width: 100%;
        overflow: hidden;
        overflow-y: scroll;
        padding: 0 0 32px;
        background: #fff;
    }

    div.list-box-wrap {

        div.list-box-header {
            padding: 32px 32px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: sticky;
            top: 0;
            left: 0;
            background-color: #fff;
            z-index: 15;
        }

        div.action-btn-wrap {
            display: flex;
            align-items: center;
            gap: 12px;

            span {
                color: #3B3B3B;
                font-size: 12px;
                font-weight: 500;
                line-height: 16px; /* 133.333% */
                letter-spacing: -0.12px;

                &.active {
                    color: var(--Gray-1000_-262626, #262626);
                }
            }
        }

        div.ordering-btn-wrap {
            display: flex;
            gap: 4px;
            align-items: center;

            button {
                width: 24px;
                height: 24px;
            }
        }
    }

    div.clip-name-wrap {
        padding: 0 32px 24px;
        border-bottom: 1px solid var(--line-table-section-line, #eee);

        label {
            color: var(--Gray-1000_-262626, #262626);
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 138.462% */
            letter-spacing: -0.13px;
        }

        input {
            height: 32px;
        }
    }

    div.content-header {
        position: relative;
        padding: 12px 24px;
        background-color: #242424;

        svg {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 24px;
            cursor: pointer;
        }
    }

    div.list-box-container {
        padding: 0 32px;
        font-size: 12px;

        //갤러리

        &.gallery .box-wrap {
            width: calc(33.33% - 12px);
            margin-right: 18px;
            margin-bottom: 24px;
            display: inline-block;

            &:nth-of-type(3n) {
                margin-right: 0;
            }

            div.list-thumbnail-wrap {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                & .checkbox {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    z-index: 10;
                }

                & .thumbnail-wrap {
                    width: 100%;
                    height: 128px;
                    border: 1px solid var(--line-table-section-line, #eee);
                    position: relative;

                    img {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }

                & .restDate {
                    line-height: 1;
                    position: absolute;
                    bottom: 30px;
                    left: 50%;
                    transform: translateX(-50%);
                    text-align: center;
                    color: #FF0000;
                    font-size: 12px;
                }
            }

            div.list-name-wrap {
                position: relative;
                margin-top: 8px;
                width: 100%;
                padding: 0 12px;
                text-align: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                line-height: 1;

                span {
                    color: #262626;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    letter-spacing: -0.12px;
                }


            }
        }

        // 리스트

        &.list .box-wrap {
            width: 100%;
            padding: 10px;
            border-top: 1px solid #ccc;
            height: 42px;

            & .list-thumbnail-wrap {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;

                & .thumbnail-wrap {
                    margin: 0 10px;
                    width: 18px;
                    flex-shrink: 0;
                }

                & .list-name-wrap {
                    order: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0 20px 0 0;
                    line-height: 1;

                    span {
                        color: #262626;
                        font-size: 13px;
                        font-weight: 400;
                        line-height: 18px; /* 138.462% */
                        letter-spacing: -0.13px;
                    }
                }

                & .restDate {
                    order: 2;
                    margin-left: auto;
                    white-space: nowrap;
                    line-height: 1;
                    color: #262626;
                }

            }
        }

        &.list .box-wrap:last-child {
            border-bottom: 1px solid #ccc;
        }
    }

    & + .full-name {
        position: fixed;
        color: #fff;
        font-size: 11px;
        white-space: nowrap;
        padding: 3px 5px;
        border-radius: 4px;
        background: #161616;
        text-align: center;
        z-index: 99999;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: -0.11px;
    }
`;


const LeftNavigation = styled.div`
    position: relative;
    width: 260px;
    flex-shrink: 0;
    overflow: hidden;
    overflow-y: scroll;
    border-left: 1px solid #EEE;
    background: #FAFAFA;
    font-size: 12px;

    div.header {
        padding: 32px 24px;

        h1 {
            color: #262626;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px; /* 150% */
            letter-spacing: -0.16px;
        }
    }

    & .folder-name {
        padding: 0 32px 40px;
        border-bottom: 1px solid #EEE;
        display: flex;
        flex-direction: column;
        align-items: center;

        & .name {
            margin-top: 15px;
            text-align: center;
            word-wrap: break-word;
            word-break: break-all;
            color: #262626;
            font-size: 12px;
            font-weight: 500;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.12px;
        }
    }

    & .folder-info {
        padding: 24px;

        & li {
            display: flex;

            > div {
                color: #262626;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px; /* 133.333% */
                letter-spacing: -0.12px;
            }

            & .title {
                width: 65px;
                flex-shrink: 0;
            }

            & .desc {
                margin-left: 12px;
                width: calc(100% - 65px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }

        & li + li {
            margin: 12px 0 0;
        }

        & .noData {
            text-align: center;
            margin: 100px 0 0;
            font-size: 12px;
            color: #a8a8a8;
            line-height: 1.4;
        }
    }
`;


export default observer(MainFolderTrashModal);

